import React, { useState, useContext, useEffect, useRef } from 'react';
import { SnackBar } from '../../components/general/snackbar.jsx'  
import {Grid, Paper, Avatar, Button, CssBaseline, TextField, Typography} from '@mui/material';

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CircularProgress from '@mui/material/CircularProgress';
import { login } from '../../services/auth';
import userContext from '../../context/userContext';

const styles = {
  root: {
    height: "100vh",
  },
  image: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  paper: {
    margin: '8px 4px',
    padding:'0px 10px',
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent:'center',
    height:'80%'
  },
  avatar: {
    margin: '',
    backgroundColor: 'secondary.main'
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: 1
  },
  submit: {
    margin: '3, 0, 2'
  }
};

const SignIn = () => {

    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [errors, setErrors] = useState({});
    const [snackBar, setSnackBar] = useState({type: "", show: false, message: ""});
    const [loading, setLoading] = useState(false)
    const { setUserStore } = useContext(userContext)
    const stateRef = useRef({ username, password });

    useEffect(() =>{
        document.addEventListener("keydown", listener);
        return () => {
            document.removeEventListener("keydown", listener);
        }
    }, [])
    
    const listener = event => {
        if (event.code === "Enter" || event.keyCode === 13) {
            doLogin(event)
        }
    };

    useEffect(()=>{
      stateRef.current = { username, password }
    }, [username, password])

    const doLogin = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const user = await login({username: stateRef.current.username, password: stateRef.current.password});
            setUserStore(user.payload)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            setSnackBar({...snackBar, show: true, message: 'Could not login', type: 'error'})
        }
    };



      return (
        <Grid container component="main" sx={styles.root}>
          <CssBaseline />
          <Grid item xs={false} sm={4} md={7}  sx={styles.image} />
          <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
            <div style={styles.paper}>
              <Avatar sx={styles.avatar}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Sign in
              </Typography>
              <div style={styles.form} >
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  value={username}
                  onChange={(e)=>{setUsername(e.target.value)}}
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e)=>{setPassword(e.target.value)}}
                  autoComplete="current-password"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={doLogin}
                  sx={styles.submit}
                  disabled={loading}
                >
                  Sign In
                  {loading && <CircularProgress size={20} sx={{ color: 'white', marginLeft:'20px' }}/>}
                </Button>
              </div>
            </div>
          </Grid>
          <SnackBar
            message={snackBar.message}
            open={snackBar.show}
            severity={snackBar.type}
            handleClose={
                ()=>{
                    setSnackBar({...snackBar, show: false})
                }
            }
            />
        </Grid>
      );
};



export default SignIn;
